"use client"

import { Link } from "react-router-dom"
import { ArrowRight, BookOpen, Users } from "lucide-react"
import FadeIn from "@/components/ui/fade-in"
import { motion } from "framer-motion"

const CTASection = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-slate-950 overflow-hidden border-t border-white/5">
      {/* Dynamic background institutional accents - Back to Sophisticated Deep Blue */}
      {/* Static ambient background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-full bg-blue-900/20 blur-[180px] pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-sm overflow-hidden bg-white/[0.02] backdrop-blur-3xl px-8 py-16 md:px-20 md:py-20 border border-white/10 shadow-[0_50px_100px_-20px_rgba(0,0,0,0.8)]"
        >

          {/* Institutional Grid Overlay */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
            style={{
              backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
              backgroundSize: "60px 60px",
            }}
          />

          {/* Ambient professional glow */}
          <div className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full bg-blue-500/10 blur-[150px] pointer-events-none" />
          <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#b48c36]/10 blur-[120px] pointer-events-none" />

          {/* Decorative top seal */}
          <div className="absolute top-12 left-1/2 -translate-x-1/2 flex items-center gap-6">
            <div className="w-20 h-px bg-white/10" />
            <div className="w-2 h-2 rotate-45 border border-[#b48c36]" />
            <div className="w-20 h-px bg-white/10" />
          </div>

          {/* Content */}
          <div className="relative z-10 max-w-2xl mx-auto text-center">

            <FadeIn delay={0}>
              <p className="text-[#b48c36] font-bold text-[11px] uppercase tracking-[0.4em] mb-6">
                Commence Your Tenure
              </p>
            </FadeIn>

            <FadeIn delay={0.1}>
              <h2 className="font-serif font-medium text-4xl md:text-5xl lg:text-[48px] text-white leading-tight tracking-tight mb-6">
                Your Selection <br/>
                <span className=" font-light text-[#b48c36]">is an Institutional Mandate.</span>
              </h2>
            </FadeIn>

            <FadeIn delay={0.2}>
              <p className="text-slate-400 text-base leading-relaxed max-w-xl mx-auto mb-10 font-light">
                Join the highest echelon of civil service training. We transform aspirants into administrators through rigorous, time-tested pedagogy.
              </p>
            </FadeIn>

            <FadeIn delay={0.4}>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                <Link
                  to="/#courses"
                  className="group inline-flex items-center gap-3 bg-[#b48c36] text-white hover:bg-white hover:text-[#b48c36] font-bold text-sm uppercase tracking-widest px-10 py-4 transition-all duration-300 shadow-2xl"
                >
                  Enter the Catalog
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-white/50 hover:text-white border border-white/10 hover:border-[#b48c36] font-semibold text-sm uppercase tracking-widest px-10 py-4 transition-all duration-300"
                >
                  Schedule Peer Council
                </Link>
              </div>
            </FadeIn>
          </div>

          {/* Decorative bottom seal */}
          <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-6">
            <div className="w-20 h-px bg-white/10" />
            <div className="w-2 h-2 rotate-45 border border-[#b48c36]" />
            <div className="w-20 h-px bg-white/10" />
          </div>

        </motion.div>
      </div>
    </section>
  )
}

export default CTASection
